DEBUG = typeof DEBUG === 'undefined' ? false : DEBUG;
ASSERT = typeof ASSERT === 'undefined' ? false : ASSERT;

module.exports.now = function() {
  return Date.now();
}

module.exports.diff = function(time) {
  return Date.now() - time;
}



//////////////////
// WEBPACK FOOTER
// ../~/planck-js/lib/util/Timer.js
// module id = 24
// module chunks = 0